import * as React from 'react';
import {VideoItem} from '../VideoItem';
import {IEnums} from '../../../../../../state/IEnums';
import {IAssetDetails, IAssetVideo, IErrorLog} from '../../../../../../../@types/assetDetails';
import {IMetadataError} from '../../../../../../../@types/metadataErrors';
import {PlaylistAsset} from '../../../../../../models/PlaylistAsset/PlaylistAsset';

interface IVideoConfigProps {
  selectedAsset: PlaylistAsset;
  updatedAssetDetails: Partial<IAssetDetails>;
  assetDetails: IAssetDetails;
  videoMetadataErrors: Array<IMetadataError>;
  enums: IEnums;
  tabsDataInEditMode: boolean;
  closestBody?: HTMLElement;
  errorLogs: Array<IErrorLog>;
  getEvents: () => void;
  updatePartialAssetDetails: (assetDetails: Partial<IAssetDetails>) => void;
}

interface IVideoConfigState {
  openCollapsibleContent: boolean;
}

export class VideoConfig extends React.Component<IVideoConfigProps, IVideoConfigState> {
  constructor(props) {
    super(props);

    this.state = {
      openCollapsibleContent: this.props.tabsDataInEditMode
    };
  }

  render() {
    return (
      <div className="metadata-video-container">
        {this.props.assetDetails.videos.map((video: IAssetVideo, index) => {
          return (
            <VideoItem
              key={index}
              enums={this.props.enums}
              video={video}
              getEvents={this.props.getEvents}
              assetDetails={this.props.assetDetails}
              updatedAssetDetails={this.props.updatedAssetDetails}
              updatePartialAssetDetails={this.props.updatePartialAssetDetails}
              videoMetadataErrors={this.props.videoMetadataErrors}
              tabsDataInEditMode={this.props.tabsDataInEditMode}
              closestBody={this.props.closestBody}
              errorLogs={this.props.errorLogs}
              openCollapsibleContent={this.state.openCollapsibleContent}
              onCollapsibleToggle={(openCollapsibleContent: boolean) => this.setState({openCollapsibleContent})}
            />
          );
        })}
      </div>
    );
  }
}
